<template>
  <div class="slide" ref="slideContainer">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.slide {
  overflow-anchor: none;
  flex: 0 0 100%;
  transition: transform 0.3s ease-in-out;
}
</style>
